import { render } from "./PendingDepositMobile.vue?vue&type=template&id=024a7861&ts=true"
import script from "./PendingDepositMobile.vue?vue&type=script&lang=ts"
export * from "./PendingDepositMobile.vue?vue&type=script&lang=ts"

import "./PendingDepositMobile.vue?vue&type=style&index=0&id=024a7861&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/buyCrypto/PendingDepositMobile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "024a7861"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('024a7861', __exports__)) {
    api.reload('024a7861', __exports__)
  }
  
  module.hot.accept("./PendingDepositMobile.vue?vue&type=template&id=024a7861&ts=true", () => {
    api.rerender('024a7861', render)
  })

}


export default __exports__